/**
 * Created by shaun on 16/09/2017.
 */

import Vue from 'vue';

import {EMPTY, READY, LOADING, UPDATING, ERROR} from 'module/constants';
import common from 'module/common';

const SET_SELECTED_STATE = 'selectedState';
const SET_SELECTED_COMPANY = 'selectedCompany';
const SET_COMPANIES_REDUCED = 'companiesReduced';
const SET_FILTERED_PROJECTS = 'filteredProjects';
const SET_SELECTED_COMPANY_CUSTOM_REPORT_PACKS = 'selectedCompanyCustomReportPacks';

const UPDATE_SAVING_STATE = 'savingState';
const UPDATE_LAST_SAVED = 'lastSaved';

// initial state
const state = {
  selected: {
    state: EMPTY,
    company: null,
    customReportPacks: []
  },
  filteredCompanyProjects: [],
  companiesReduced: [],
  saving: {},
  availableNoteTags: ['Estimating Service', 'Feedback', 'Account Creator Contact', 'Teamviewer Details', 'Renewal Call', 'Follow Up Call', 'Estimating'],
  lastSaved: {
    company: null,
    companyAs: {
      search: null
    }
  }
};

//actions
const actions = {
  select({state, commit, dispatch, rootGetters}, company) {
    if (!company._id && !company.accountNumber) {
      return;
    }

    if (company._refresh === true) {
      commit(SET_SELECTED_STATE, UPDATING);
    } else {
      commit(SET_SELECTED_STATE, LOADING);
    }

    common
      .httpPost('company')
      .data({
        action: 'get',
        companyId: company._id,
        accountNumber: company.accountNumber,
        idToken: rootGetters['user/idToken']()
      })
      .then((res) => {
        dispatch('selectUsingCompanyObject', res.data);
        commit(SET_COMPANIES_REDUCED, []);
      }, (error) => {
        console.log('Error', error);
        dispatch('error/error', error, {root: true});
        commit(SET_SELECTED_STATE, ERROR);
      });
  },
  selectUsingCompanyObject({commit}, company) {
    commit(SET_SELECTED_STATE, READY);
    commit(SET_SELECTED_COMPANY, company);
  },
  addCompany({commit, dispatch, rootGetters}, {form, source}) {
    form.quoteInfo.builder.addAsUser = !!form.quoteInfo.builder.addAsUser;

    commit(UPDATE_SAVING_STATE, {companyId: 'COMPANY_ADD', action: 'ADD', newState: UPDATING});
    return common
      .httpPost('company')
      .data({action: 'add',
        form,
        idToken: rootGetters['user/idToken'](),
        source})
      .then((res) => {
        commit(UPDATE_SAVING_STATE, {companyId: 'COMPANY_ADD', action: 'ADD', newState: READY});
        commit(SET_SELECTED_COMPANY, res.data.company);
      }, (error) => {
        console.log('Error', error);
        dispatch('error/error', error, {root: true});
        commit(UPDATE_SAVING_STATE, {companyId: 'COMPANY_ADD', action: 'ADD', newState: ERROR});
        throw error;
      });
  },
  clearFilteredProjects({commit}) {
    commit(SET_FILTERED_PROJECTS, []);
  },
  filterCompanyProjects({state, commit}, filterParam) {
    if (filterParam === null) {
      commit(SET_FILTERED_PROJECTS, []);
      return;
    }

    const companyProjects = _.get(state, 'selected.company.projects.all', []);
    let filteredProjects = [];

    _.forEach(companyProjects, (project) => {
      if (typeof project !== 'object') {
        return;
      }

      let address = '';

      const addressObj = _.get(project, 'projectAddress', {});

      _.forEach(addressObj, (value) => {
        if (typeof value === 'string') {
          address += value + ' ';
        }
      });

      if (address.toLowerCase().includes(filterParam.toLowerCase())) {
        filteredProjects.push(project);
      }
    });

    commit(SET_FILTERED_PROJECTS, filteredProjects);
  },
  refresh({state, dispatch}) {
    if (state.selected.state === READY && state.selected.company !== null) {
      dispatch('select', {
        _id: state.selected.company._id,
        _refresh: true
      });
    }
  },
  notifySlack({commit, dispatch}, {quote, channel, title, fields}) {
    dispatch('save', {
      quote,
      label: 'Notify Slack',
      action: 'notifySlack',
      data: {
        channel,
        title,
        fields
      }
    });
  },
  clickToCall({commit, dispatch}, {company, person, telephone}) {
    dispatch('save', {
      company,
      label: 'Click To Call',
      action: 'clickToCall',
      data: {
        person,
        telephone
      }
    });
  },
  builderDetails({commit, dispatch}, {company, name, builderType, address, contacts, accounts, onlinePresence}) {
    return dispatch('save', {
      company,
      label: 'Builder Details',
      action: 'builderDetails',
      data: {
        name,
        builderType,
        address,
        contacts,
        accounts,
        onlinePresence
      }
    });
  },
  addUser({commit, dispatch}, {company, contact}) {
    return dispatch('save', {
      company,
      label: 'Add A User',
      action: 'addUser',
      data: {
        contact: contact,
        contactId: contact.id,
        contactEmail: contact.email,
      }
    })
  },
  updateBranch({commit, dispatch}, {company, branchNumber, preferredStakeholders}) {
    dispatch('save', {
      company,
      label: 'Update Branch',
      action: 'updateBranch',
      data: {
        branchNumber,
        preferredStakeholders
      }
    });
  },
  updateFormPreferences({commit, dispatch}, {company, updateExistingQuotes, form}) {
    dispatch('save', {
      company,
      label: 'Form Preferences',
      action: 'formPreferences',
      data: {
        updateExistingQuotes,
        form: form
      }
    });
  },
  updateCommunicationPreferences({commit, dispatch}, {company, contactable, marketing}) {
    dispatch('save', {
      company,
      label: 'Marketing Preferences',
      action: 'communicationPreferences',
      data: {
        contactable,
        marketing
      }
    });
  },
  updateReportsPreferences({commit, dispatch}, {company, frontCoverName, plansPageRequired, comparerPageRequired}) {
    dispatch('save', {
      company,
      label: 'Update Reports Preferences',
      action: 'updateReportsPreferences',
      data: {
        frontCoverName,
        plansPageRequired,
        comparerPageRequired
      }
    });
  },
  addQuote({commit, dispatch, state}, {company, brand, note, form, serviceType, contacts, sourceCampaign, plans}) {
    return dispatch('save', {
      company,
      label: 'Add Quote',
      action: 'addQuote',
      data: {
        brand,
        form,
        serviceType,
        note,
        contacts,
        sourceCampaign,
        files: {
          plans
        }
      }
    }).then(() => {
      return dispatch('quote/select', {ref: _.last(state.selected.company.projects.all).ref}, {root: true});
    }, () => {
    });
  },
  setCompanyState({commit, dispatch}, {company, state, stateReason}) {
    dispatch('save', {
      company,
      label: 'Company Status',
      action: 'companyState',
      data: {
        state,
        stateReason: stateReason || null
      }
    });
  },
  requestContactRemoval({commit, dispatch}, {company, contact, optionValue}) {
    dispatch('save', {
      company,
      label: 'Request Contact Removal',
      action: 'requestContactRemoval',
      data: {
        contactName: contact,
        reasonForRemoval: optionValue
      }

    });
  },
  feedbackTagEmail({commit, dispatch}, {company, nameOfCompany, userMessage}) {
    dispatch('save', {
      company,
      label: 'User Feedback ',
      action: 'feedbackTagEmail',
      data: {
        userNote: userMessage,
        companyName: nameOfCompany,
      }
    })
  },
  sendLeadToAccountCreator({commit, dispatch}, {company}) {
    dispatch('save', {
      company,
      label: 'Account Creator Contact ',
      action: 'sendLeadToAccountCreator',
      data: {
      }
    })
  },
  requestToRemoveData({commit, dispatch}, company) {
    dispatch('save', {
      company,
      label: 'Request To Remove User Data',
      action: 'requestToRemoveData'

    })
  },
  addPceTokensToCompany({commit, dispatch}, {companyToUse, numberToAdd}){
    dispatch('save', {
      company: companyToUse,
      label: 'Add to companies PCE Tokens',
      action: 'addTokenToCompany',
      data : {
        numberToAdd: numberToAdd
      }

    })
  },
  setAvailabilityForWork({commit, dispatch}, {company, availabilityForWork}) {
    dispatch('save', {
      company,
      label: 'Availability For Work',
      route: 'availabilityForWork.set',
      data: {
        availabilityForWork,
      }
    });
  },
  setPreferredEstimator({commit, dispatch}, {company, estimator}) {
    dispatch('save', {
      company,
      label: 'Preferred Estimator',
      action: 'preferredEstimator',
      data: {
        estimator,
      }
    });
  },
  async addNote({commit, dispatch}, {selected, note, tags, recipients}) {
    return dispatch('save', {
      company: selected,
      label: 'Add Note',
      action: 'addNote',
      data: {
        note,
        tags,
        recipients
      }
    });
  },
  async deleteNote({commit, dispatch}, {selected, noteId}) {
    return dispatch('save', {
      company: selected,
      label: 'Delete Note',
      action: 'deleteNote',
      data: {
        noteId
      }
    });
  },
  async updateNote({commit, dispatch}, {selected, noteId, note}) {
    return dispatch('save', {
      company: selected,
      label: 'Update Note',
      action: 'updateNote',
      data: {
        noteId,
        note
      }
    });
  },
  setNotAsDealtWith({commit, dispatch}, {selected, noteId}) {
    dispatch('save', {
      company: selected,
      label: 'Add Note',
      action: 'setNotAsDealtWith',
      data: {
        noteId,
      }
    });
  },
  merge({commit, dispatch}, {company, targetCompany}) {
    dispatch('save', {
      company,
      label: 'Company Merge',
      action: 'companyMerge',
      data: {
        targetCompany
      }
    });
  },
  uploadLogo({commit, dispatch}, {company, logo}) {
    dispatch('save', {
      company,
      label: 'Upload Logo',
      action: 'uploadLogo',
      data: {
        files: {
          logo
        }
      }
    });
  },
  uploadCustomPackImages({commit, dispatch}, {company, images}) {
    dispatch('save', {
      company,
      label: 'Upload Custom Pack Images',
      action: 'uploadCustomPackImages',
      data: {
        files: {
          images
        }
      }
    });
  },
  removeLogo({commit, dispatch}, {company}) {
    dispatch('save', {
      company,
      label: 'Remove Logo',
      action: 'removeLogo'
    });
  },
  addTag({commit, dispatch}, {company, tag}) {
    dispatch('save', {
      company,
      label: 'Add Tag',
      action: 'addTag',
      data: {
        tag
      }
    });
  },
  removeTag({commit, dispatch}, {company, tag}) {
    dispatch('save', {
      company,
      label: 'Remove Tag',
      action: 'removeTag',
      data: {
        tag
      }
    });
  },
  setTags({commit, dispatch}, {company, tags}) {
    dispatch('save', {
      company,
      label: 'Set Tags',
      action: 'setTags',
      data: {
        tags
      }
    });
  },
  setPersonResponsible({commit, dispatch}, {company, personResponsible}) {
    dispatch('save', {
      company,
      label: 'Set Person Responsible',
      action: 'setPersonResponsible',
      data: {
        personResponsible
      }
    });
  },
  addWorkflow({commit, dispatch}, {company, workflowName}) {
    dispatch('save', {
      company,
      label: 'Add Workflow',
      action: 'addWorkflow',
      data: {
        workflowName
      }
    });
  },
  setWorkflowState({commit, dispatch}, {company, workflowId, state, reason}) {
    dispatch('save', {
      company,
      label: 'Set Workflow State',
      action: 'setWorkflowState',
      data: {
        workflowId,
        state,
        reason
      }
    });
  },
  setSourceForWorkflow({commit, dispatch}, {
    company,
    workflowId,
    dateReceived,
    source,
    referer,
    campaignId,
    employeeReferredBy
  }) {
    dispatch('save', {
      company,
      label: 'Set Workflow Source',
      action: 'setSourceForWorkflow',
      data: {
        workflowId,
        dateReceived,
        source,
        campaignId,
        employeeReferredBy,
        referer: referer || window.location.href
      }
    });
  },
  setSupportDetailsForWorkflow({commit, dispatch}, {company, workflowId, supportDetails}) {
    dispatch('save', {
      company,
      label: 'Set Workflow Support Details',
      action: 'setSupportDetailsForWorkflow',
      data: {
        workflowId,
        supportDetails
      }
    });
  },
  setWorkflowDueDate({commit, dispatch}, {company, workflowId, dueDate, daysTilDue}) {
    dispatch('save', {
      company,
      label: 'Set Workflow Due Date',
      action: 'setWorkflowDueDate',
      data: {
        workflowId,
        dueDate,
        daysTilDue
      }
    });
  },
  setWorkflowCurrentStepDueDate({commit, dispatch}, {company, workflowId, dueDate, daysTilDue}) {
    dispatch('save', {
      company,
      label: 'Set Workflow Current Step Due Date',
      action: 'setWorkflowCurrentStepDueDate',
      data: {
        workflowId,
        dueDate,
        daysTilDue
      }
    });
  },
  assignTo({commit, dispatch}, {company, workflowId, user, step}) {
    dispatch('save', {
      company,
      label: 'Assign Workflow Step',
      action: 'assignTo',
      data: {
        workflowId,
        user,
        step
      }
    });
  },
  getProducts({state, commit, rootGetters, dispatch}, {branch, query}) {
    let idToken = rootGetters['user/idToken']();

    common.httpPost('product')
        .data({
          idToken,
          branchNumber: branch.number,
          search: query
        })
        .then((res) => {
          commit(SET_PRODUCTS, res.data);
        }, (error) => {
          dispatch('error/error', error, {root: true});
        });
  },
  startStep({commit, dispatch}, {company, workflow}) {
    dispatch('save', {
      company,
      label: 'Start Step',
      action: 'startStep',
      data: {
        workflow
      }
    });
  },
  completeStep({commit, dispatch}, {company, workflow}) {
    dispatch('save', {
      company,
      label: 'Complete Step',
      action: 'completeStep',
      data: {
        workflow
      }
    });
  },
  goBackToStep({commit, dispatch}, {company, workflow, step}) {
    dispatch('save', {
      company,
      label: 'Go Back To Step',
      action: 'goBackToStep',
      data: {
        workflow,
        step
      }
    });
  },
  setStepDueDate({commit, dispatch}, {company, workflow, step, dueDate}) {
    dispatch('save', {
      company,
      label: 'Step Due Date',
      action: 'setStepDueDate',
      data: {
        workflow,
        step,
        dueDate
      }
    });
  },
  setActiveReportPackTemplate({commit, dispatch}, {company, reportPackId}) {
    dispatch('save', {
      company,
      label: 'Set Active Report Pack Template',
      action: 'setActiveReportPackTemplate',
      data: {
        reportPackId
      }
    });
  },
  resetToStandardPack({commit, dispatch}, {company}) {
    dispatch('save', {
      company,
      label: 'Reset To Standard Pack',
      action: 'resetToStandardPack',
      data: {}
    });
  },
  getCustomReportPacks({state, commit, dispatch, rootGetters}, {company}) {
    return new Promise((resolve, reject) => {
      common
          .httpPost('company')
          .data({
            idToken: rootGetters['user/idToken'](),
            action: 'getCustomReportPacks',
            companyId: company._id,
          })
          .then((res) => {
            commit(SET_SELECTED_COMPANY_CUSTOM_REPORT_PACKS, res.data.customReportPacks);
          }, () => {
            reject();
          })
    });
  },
  saveSale({commit, dispatch}, {company, sale, filesToAdd, filesToRemove}) {
    dispatch('save', {
      company,
      label: 'Save Sale',
      action: 'saveSale',
      data: {
        company,
        sale,
        filesToRemove,
        files: {
          filesToAdd
        }
      }
    });
  },
  getCompaniesReduced({state, commit, rootGetters, dispatch}, {companySearchParam}) {
    common.httpPost('company')
        .data({
          action: 'getCompaniesReduced',
          idToken: rootGetters['user/idToken'](),
          companySearchParam: companySearchParam
        })
        .then((res) => {
          commit(SET_COMPANIES_REDUCED, res.data);
        }, (error) => {
          dispatch('error/error', error, {root: true});
        });
  },
  setMBSTypeForCompany({commit, dispatch}, {company, mbsType}) {
    dispatch('save', {
      company,
      label: 'Set MBS Type',
      action: 'setMBSTypeForCompany',
      data: {
        mbsType
      }
    });
  },
  requestCallback({commit, dispatch}, {company, reason}) {
    commit(SET_SELECTED_STATE, UPDATING);
    commit(UPDATE_SAVING_STATE, {companyId: company._id, action: 'requestCallback', newState: UPDATING});

    common
        .httpPost('company')
        .recaptchaAction('requestCallback')
        .data({
          action: 'requestCallback',
          companyId: company._id,
          reason: reason,
        })
        .then((res) => {
          commit(UPDATE_SAVING_STATE, {companyId: company._id, action: 'requestCallback', newState: READY});
        }, (error) => {
          dispatch('error/error', error, {root: true});
          commit(UPDATE_SAVING_STATE, {companyId: company._id, action: 'requestCallback', newState: READY});
          commit(SET_SELECTED_STATE, ERROR);
        });
  },
  save({commit, dispatch, state, rootGetters, rootState}, {company, label, action, route, data}) {
    return new Promise((resolve, reject) => {
      dispatch('error/clear', null, {root: true});
      data = _.merge({
        companyId: company._id,
        idToken: rootGetters['user/idToken'](),
        action,
        route
      }, data);

      if (company._searchStore) {
        data.view = rootState[company._searchStore].view;
        data.search = rootState[company._searchStore].search;
        data.filterValues = rootState[company._searchStore].filters.selected;
        data.filterValues = _.isEmpty(data.filterValues) === false ? data.filterValues : null;
      }

      commit(SET_SELECTED_STATE, UPDATING);
      commit(UPDATE_SAVING_STATE, {companyId: company._id, action, newState: UPDATING});

      if (state.selected.company !== null && state.selected.company._id && company._id) {
        commit(SET_SELECTED_STATE, UPDATING);
      }

      common
          .httpPost('company')
          .recaptchaAction(action)
          .data(data)
          .then((res) => {
            let data = res.data;

            commit(UPDATE_SAVING_STATE, {companyId: company._id, action, newState: READY});
            commit(UPDATE_LAST_SAVED, data);

            if (company._searchStore && data.companyAs.search === null) {
              dispatch(company._searchStore + '/removeRow', company, {root: true});
            } else if (company._searchStore) {
              dispatch(company._searchStore + '/updateRow', {
                rowId: company._searchStoreRowId || null,
                rowToUpdate: data.companyAs.search
              }, {root: true});
            }

            dispatch('quote/refresh', null, {root: true});

            if (rootState.view.searchStore.company) {
              //Reset current project search store as it could be outdated after save
              dispatch(rootState.view.searchStore.company.reset, null, {root: true});
            }

            if (state.selected.company !== null && state.selected.company._id && company._id) {
              commit(SET_SELECTED_STATE, READY);
              commit(SET_SELECTED_COMPANY, data.company);
            }
            resolve();
          }, (error) => {
            console.log('Error', data.label, data, error);
            dispatch('error/error', error, {root: true});
            commit(UPDATE_SAVING_STATE, {companyId: company._id, action, newState: READY});
            if (state.selected.company !== null && state.selected.company._id && company._id) {
              commit(SET_SELECTED_STATE, ERROR);
            }
            reject();
          });
    });
  }
};

//getters
const getters = {
  activeContacts(state) {
    return _.get(state, 'selected.company.contacts', []).filter((contact) => {
      return contact.isDeleted !== true;
    });
  },
  accountNumbers(state) {
    return _.get(state, 'selected.company.accounts.all', []).map((account) => {
      return account.account;
    });
  },
  isSaving: (state) => (companyId, type) => {
    let key = [companyId, type].join('_');
    return state.saving[key] && state.saving[key] === UPDATING;
  },
  savingState: (state) => (companyId, type) => {
    let key = [companyId, type].join('_');
    return state.saving[key] && state.saving[key] === UPDATING;
  },
  totalSaving(state) {
    return Object.keys(state.saving).length;
  },
  selectedCompany(state) {
    return _.get(state, 'selected.company', null);
  },
  availableTokens(state) {
    const companyTokens = _.get(state, 'selected.company.tokens', {});
    let availableTokens = {};

    _.forEach(companyTokens, (tokens, type) => {
      _.forEach(tokens, (token, key) => {
        if (new Date(token.expires) < Date.now() && token.used === null) {
          availableTokens[type] = token;
        }
      });
    });

    return availableTokens;
  },
  availableTokensForType: (state) => (type) => {
    const companyTokens = _.get(state, 'selected.company.tokens', {});
    if (!companyTokens[type]) {
      return [];
    }

    return _.filter(companyTokens[type], (token, key) => {
      const tokenExpiry = parseInt(token.date.expires["$date"]["$numberLong"], 10);
      return new Date(tokenExpiry) > Date.now() && token.date.used === null;
    });
  },
};

// mutations
const mutations = {
  [SET_SELECTED_STATE](state, newState) {
    state.selected.state = newState;
  },
  [SET_SELECTED_COMPANY](state, company) {
    state.selected.company = company;
  },
  [SET_SELECTED_COMPANY_CUSTOM_REPORT_PACKS](state, customReportPacks) {
    state.selected.customReportPacks = customReportPacks;
  },
  [SET_COMPANIES_REDUCED](state, companies) {
    state.companiesReduced = companies;
  },
  [SET_FILTERED_PROJECTS](state, filteredProjects) {
    state.filteredCompanyProjects = filteredProjects;
  },
  [UPDATE_SAVING_STATE](state, {companyId, action, newState},) {
    let key = [companyId, action].join('_');

    if (newState !== READY) {
      Vue.set(state.saving, key, newState);
    } else if (state.saving[key]) {
      state.saving[key] = null;
      delete state.saving[key];
    }
  },
  [UPDATE_LAST_SAVED](state, {company, companyAs}) {
    state.lastSaved.company = company;
    state.lastSaved.companyAs = companyAs;
  },
};

export default {
  state,
  actions,
  getters,
  mutations
}